var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#53A5F4",
    d: "M3 5c0-.6.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1m1 8c0-.6.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1H5c-.6 0-1-.4-1-1m0 3c-.6 0-1 .4-1 1s.4 1 1 1h5c.6 0 1-.4 1-1s-.4-1-1-1zM18 5c0-.6.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1h-2c-.6 0-1-.4-1-1M7 20c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zM3 10c-.6 0-1-.4-1-1s.4-1 1-1h9c1.1 0 2-.9 2-2s-.9-2-2-2c-.6 0-1.1.2-1.4.6c-.4.4-1 .4-1.4 0s-.4-1 0-1.4C9.9 2.5 10.9 2 12 2c2.2 0 4 1.8 4 4s-1.8 4-4 4zm16 2c.6 0 1-.4 1-1s-.4-1-1-1c-.3 0-.5.1-.7.3c-.4.4-1 .4-1.4 0s-.4-1 0-1.4c.5-.6 1.3-.9 2.1-.9c1.7 0 3 1.3 3 3s-1.3 3-3 3h-9c-.6 0-1-.4-1-1s.4-1 1-1zm-1 6h-5c-.6 0-1-.4-1-1s.4-1 1-1h5c1.7 0 3 1.3 3 3s-1.3 3-3 3c-.8 0-1.6-.3-2.1-.9c-.4-.4-.4-1 0-1.4s1-.4 1.4 0c.2.2.4.3.7.3c.6 0 1-.4 1-1s-.4-1-1-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.418fc6936964ea49581ceb9a53b495f0.svg";
export { ForwardRef as ReactComponent };